// NOTE: sample
export const SAMPLE = 'SAMPLE'
export const SET_DASHBOARD = 'SET_DASHBOARD'
export const SET_ROOMS = 'SET_ROOMS'
export const SET_COMPANY = 'SET_COMPANY'
export const SET_USER = 'SET_USER'
export const SET_USER_SETTING = 'SET_USER_SETTING'
export const INIT_SETUP_STATE = 'INIT_SETUP_STATE'
export const SET_DONE_SETUP_STATE = 'SET_DONE_SETUP_STATE'
export const SET_SKIP_SETUP_STATE = 'SET_SKIP_SETUP_STATE'
export const SET_ACTIVE_SETUP_STATE = 'SET_ACTIVE_SETUP_STATE'
